import { Injectable } from '@angular/core';
import { User } from 'app/interfaces/user';
import { AccountService } from '../account.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'environments/environment';
import { FirebaseService } from 'app/services/firebase.service';
import { Router } from '@angular/router';
import { FacebookPixelService } from 'app/services/facebook-pixel.service';
declare var AppleID: any;


@Injectable({
  providedIn: 'root'
})
export class AppleLoginService {
  isLoading;

  constructor(
    private accountService: AccountService,
    private firebaseService: FirebaseService,
    private router: Router,
    private facebookPixelService: FacebookPixelService,
    ) {
  }

  public init(): void {
    AppleID.auth.init({
      clientId: environment.appleClientId,
      scope: 'name email',
      redirectURI: `${window.location.origin}/account/sign_up`,
      usePopup: true
    });
  }

  public async signIn(redirectUrl: string, isSignUp) {
    try {
      this.isLoading = true;
      const jwtHelper = new JwtHelperService();
      const data = await AppleID.auth.signIn();

      const appleUser = data['user'];
      const token = data['authorization']['id_token'];

      const decodedToken = jwtHelper.decodeToken(token);

      const payload = {
        user: decodedToken['sub'],
        access_token: token,
      };
      if (appleUser) {
        if (appleUser['email']) {
          payload['email'] = appleUser['email'];
        }
        if (appleUser['name']) {
          payload['first_name'] = appleUser['name']['firstName'];
          payload['last_name'] = appleUser['name']['lastName'] ;
        }
      }
      this.processSignUp(payload, redirectUrl, isSignUp);
    } catch (error) {
      console.log(error);
    }
  }


  private processSignUp(payload, redirectUrl, isSignUp) {
    this.accountService.signUpWithApple(payload, redirectUrl, isSignUp).subscribe(
      data => {
        this.firebaseService.setUserId(data.user_id);
        this.firebaseService.logEvent('sign_up', {
          method: 'apple',
        });
        this.facebookPixelService.trackEvent('CompleteRegistration' , {
          method: 'apple',
        });
        this.firebaseService.userProperties({ first_open_time: new Date() });
        this.isLoading = false;
      },
      errors => {
        this.isLoading = false;
        if (errors.status === 409) {
          this.router.navigate(['/account/login/email/']);
        }
        this.firebaseService.logEvent('sign_up_error', {
          reason: errors.detail,
        });
      }
    );
  }
}
